
import React, { useEffect, useState } from 'react'

import { useProgrammation } from '@/Hooks/UseProgrammation';
import { addResponsible } from '@/Services/ProgrammationManagerService';

import UserAvatar from '@/Components/UserAvatar/UserAvatar';

import Spinner from '@/Components/SvgImages/Spinner/Spinner';
import Check from '@/Components/SvgImages/Check';

import './UserOption.scss'
import { useDispatch } from 'react-redux';
import { updateResponsiblesAction } from '@/Redux/Actions/ProgrammationManagerActions';

interface Props {
  user: any
  subTask?: any
}

const UserOption = ({ user, subTask }: Props) => {

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const [ selecting, setSelecting ] = useState(false)
  const [ selected, setSelected ] = useState(false)

  const task = subTask || itemOpened

  const handleSelect = async () => {

    if (selected) {
      return
    }

    setEditingItem(true)
    setSelecting(true)

    const [ error, data ] = await addResponsible(task._id, user._id)

    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    if (!subTask) {

      patchItemOpened({
        responsibles: [...itemOpened.responsibles, user]
      })
    } else {

      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.responsibles = [...subTask.responsibles, user]
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateResponsiblesAction({ task: data.task, parentTask: data.parentTask }))

    setSelecting(false)
  }

  useEffect(() => {

    const userFound = task.responsibles.find((u: any) => u._id === user._id)

    setSelected(userFound)
  }, [itemOpened])

  return (
    <div className="user-option"
      onClick={handleSelect}
    >
      <div className="user-option-avatar">
        <UserAvatar user={user} size="md" />
      </div>
      <div className="user-option-content">
        <div className="user-names">
          {user.name} {user.surname}
        </div>
      </div>
      <div>
        {!selected && selecting && (
          <Spinner
            height={24}
            width={24}
          />
        )}
        {selected && (
          <Check
            height={24}
            width={24}
          />
        )}
      </div>
    </div>
  )
}

export default UserOption
